/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Rodzaj zadania. `CUSTOM` to zadanie zalozone recznie przez czlowieka, pozostale sa zakladane przez system w reakcji na zdarzenie w procesie. Front uzywa tego do ikon i filtrow — dzieki temu widac, czy pod procesem siedzi nowy mail, czy przypomnienie. 
 */

export const TaskDefinitionDto = {
    Custom: 'CUSTOM',
    ProcessFirstContact: 'PROCESS_FIRST_CONTACT',
    ProcessOnNewEmail: 'PROCESS_ON_NEW_EMAIL',
    ProcessOnNewProcess: 'PROCESS_ON_NEW_PROCESS',
    ProcessNameUpdate: 'PROCESS_NAME_UPDATE',
    ProcessCustomerUpdate: 'PROCESS_CUSTOMER_UPDATE',
    ProcessOwnerUpdate: 'PROCESS_OWNER_UPDATE',
    ProcessEventConfirmation: 'PROCESS_EVENT_CONFIRMATION',
    ProcessOfferOfferingPeriodEnd: 'PROCESS_OFFER_OFFERING_PERIOD_END',
} as const;

export type TaskDefinitionDto = typeof TaskDefinitionDto[keyof typeof TaskDefinitionDto];



